export function handleDeleteError(response, textStatus, error) {
    // 422 Unprocessable Content
    if (response.status === 422) {
        try {
            let errorMessage = '';

            // If we have responseJSON with errors property
            if (response.responseJSON && response.responseJSON.errors) {
                // If errors is a string, use it directly
                if (typeof response.responseJSON.errors === 'string') {
                    errorMessage = response.responseJSON.errors;
                }
                // If errors is an object, convert to array of messages
                else {
                    let errorArray = [];
                    for (let key in response.responseJSON.errors) {
                        if (Array.isArray(response.responseJSON.errors[key])) {
                            errorArray = errorArray.concat(response.responseJSON.errors[key]);
                        } else {
                            errorArray.push(response.responseJSON.errors[key]);
                        }
                    }
                    errorMessage = errorArray.join(', ');
                }
            }
            // If we have responseJSON with error property (singular)
            else if (response.responseJSON && response.responseJSON.error) {
                errorMessage = response.responseJSON.error;
            }
            // If we have responseJSON with message property
            else if (response.responseJSON && response.responseJSON.message) {
                errorMessage = response.responseJSON.message;
            }
            // Fallback
            else {
                errorMessage = 'Er is een fout opgetreden bij het verwerken van uw verzoek.';
            }

            // Show the error message
            if (errorMessage) {
                $.eoprompt(errorMessage);
            }
        } catch (e) {
            $.eoprompt('Er is een fout opgetreden bij het verwerken van uw verzoek.');
        }
    }
}

/**
 * Reinitialize a Select2Select element
 * @param element specify the Select element
 */
export function reinitializeSelect2SelectElement(element) {
	// Generate a new ID to use for the select2select
	const id = Date.now()

	// Get the new row Wrapper
	const selectorParent = element.parent()

	// Get the classes and options from the old select2select
	let classes = element.attr('class')
	let options = element.children()

	// Remove all currently 'selected' options attributes
	options = options.each(function () {
		return $(this).attr('data-select2-id', null);
	})

	// Create a new Select element object
	// Attach old classes, options and the new ID
	let newSelector = $("<select>")
		.attr('class', classes)
		.attr('id', id)
		.append(options);

	// Remove all old elements generated by Select2Select
	if (parent.find("span") !== undefined) {
		selectorParent.find("span").remove()
		selectorParent.find("select").remove()
	}

	// Reset the label to the correct ID
	// Add the created Select and add it to the wrapper
	selectorParent.find("label").attr("for", id)
	selectorParent.append(newSelector)

	// Reset the selectors value
	newSelector.val('');

	// Small timeout to initialize the Select2Select
	setTimeout(() => {
		newSelector.select2({
			placeholder: "Maak een keuze"
		})
	}, 50)
}

/**
 * Converts a hexadecimal color code to an RGB color representation.
 *
 * @param {string} [hex='#000000'] - The hexadecimal color code to convert. Defaults to black (`#000000`) if not provided.
 * @returns {string} A string representing the RGB values in the format `r, g, b`, where `r`, `g`, and `b` are the red, green, and blue color components respectively.
 */
export function hexToRgb(hex = '#000000') {
	// Remove hash (#) if present
	hex = hex.replace('#', '');

	// Convert hex values to integers
	const r = parseInt(hex.substring(0, 2), 16);
	const g = parseInt(hex.substring(2, 4), 16);
	const b = parseInt(hex.substring(4, 6), 16);

	return `${r}, ${g}, ${b}`;
}

export function isDarkColor(backgroundColor){
	if (!backgroundColor) return false;
	const color = backgroundColor.slice(1); // Remove '#'
	const rgb = parseInt(color, 16); // Convert hex to integer
	const r = (rgb >> 16) & 0xff;
	const g = (rgb >> 8) & 0xff;
	const b = (rgb >> 0) & 0xff;
	const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
	return luminance < 140;
}
